module.exports = __webpack_public_path__ + "img/girl.e2b587c2.jpeg";